import { styled, Button } from '@material-ui/core';

export const StyledButton = styled(Button)({
  padding: '10px 24px',
  textTransform: 'none',
  fontWeight: 500,
  '&.primary-button': {
    backgroundColor: '#383c52',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#2c2f3f',
    },
    '&:disabled': {
      backgroundColor: '#cccccc',
      color: '#ffffff',
    },
  },
});
